import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable section header component
 * Used throughout pages to introduce new sections
 */
const SectionHeader = ({ 
  badge = null,
  title, 
  description = null, 
  align = 'center',
  className = '' 
}) => {
  const alignmentClass = align === 'center' ? 'text-center' : align === 'left' ? 'text-start' : 'text-end';
  const maxWidthClass = align === 'center' ? 'max-w-600 mx-auto' : '';

  return (
    <div className={`${alignmentClass} mb-48 ${className}`}>
      {badge && (
        <span className="text-main-600 text-uppercase fw-semibold mb-16 d-block">
          {badge}
        </span>
      )}
      <h2 className="mb-16">{title}</h2>
      {description && (
        <p className={`text-neutral-600 ${maxWidthClass}`}>
          {description}
        </p>
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  badge: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  align: PropTypes.oneOf(['center', 'left', 'right']),
  className: PropTypes.string
};

export default SectionHeader;
